import styles from './ProductHeader.module.css'

interface Props {
  text: string
}

export const ProductHeader = ({ text }: Props): JSX.Element => (
  <h2 className={styles.Header}>{text}</h2>
)
